
// @ts-nocheck


export const localeCodes =  [
  "en",
  "es",
  "zh",
  "hi",
  "ar",
  "fr",
  "pt",
  "ja",
  "de",
  "vi",
  "ko",
  "ru",
  "it",
  "tr",
  "id",
  "th",
  "bn",
  "pl",
  "nl",
  "uk",
  "ur",
  "my",
  "fa",
  "he",
  "ms",
  "fil",
  "ta",
  "sw",
  "ro",
  "el",
  "cs",
  "hu",
  "sv",
  "fi",
  "km",
  "ne"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en.ts", load: () => import("../locales/en.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_en_ts" */), cache: true }],
  "es": [{ key: "../locales/es.ts", load: () => import("../locales/es.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_es_ts" */), cache: true }],
  "zh": [{ key: "../locales/zh.ts", load: () => import("../locales/zh.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_zh_ts" */), cache: true }],
  "hi": [{ key: "../locales/hi.ts", load: () => import("../locales/hi.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_hi_ts" */), cache: true }],
  "ar": [{ key: "../locales/ar.ts", load: () => import("../locales/ar.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_ar_ts" */), cache: true }],
  "fr": [{ key: "../locales/fr.ts", load: () => import("../locales/fr.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_fr_ts" */), cache: true }],
  "pt": [{ key: "../locales/pt.ts", load: () => import("../locales/pt.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_pt_ts" */), cache: true }],
  "ja": [{ key: "../locales/ja.ts", load: () => import("../locales/ja.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_ja_ts" */), cache: true }],
  "de": [{ key: "../locales/de.ts", load: () => import("../locales/de.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_de_ts" */), cache: true }],
  "vi": [{ key: "../locales/vi.ts", load: () => import("../locales/vi.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_vi_ts" */), cache: true }],
  "ko": [{ key: "../locales/ko.ts", load: () => import("../locales/ko.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_ko_ts" */), cache: true }],
  "ru": [{ key: "../locales/ru.ts", load: () => import("../locales/ru.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_ru_ts" */), cache: true }],
  "it": [{ key: "../locales/it.ts", load: () => import("../locales/it.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_it_ts" */), cache: true }],
  "tr": [{ key: "../locales/tr.ts", load: () => import("../locales/tr.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_tr_ts" */), cache: true }],
  "id": [{ key: "../locales/id.ts", load: () => import("../locales/id.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_id_ts" */), cache: true }],
  "th": [{ key: "../locales/th.ts", load: () => import("../locales/th.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_th_ts" */), cache: true }],
  "bn": [{ key: "../locales/bn.ts", load: () => import("../locales/bn.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_bn_ts" */), cache: true }],
  "pl": [{ key: "../locales/pl.ts", load: () => import("../locales/pl.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_pl_ts" */), cache: true }],
  "nl": [{ key: "../locales/nl.ts", load: () => import("../locales/nl.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_nl_ts" */), cache: true }],
  "uk": [{ key: "../locales/uk.ts", load: () => import("../locales/uk.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_uk_ts" */), cache: true }],
  "ur": [{ key: "../locales/ur.ts", load: () => import("../locales/ur.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_ur_ts" */), cache: true }],
  "my": [{ key: "../locales/my.ts", load: () => import("../locales/my.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_my_ts" */), cache: true }],
  "fa": [{ key: "../locales/fa.ts", load: () => import("../locales/fa.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_fa_ts" */), cache: true }],
  "he": [{ key: "../locales/he.ts", load: () => import("../locales/he.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_he_ts" */), cache: true }],
  "ms": [{ key: "../locales/ms.ts", load: () => import("../locales/ms.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_ms_ts" */), cache: true }],
  "fil": [{ key: "../locales/fil.ts", load: () => import("../locales/fil.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_fil_ts" */), cache: true }],
  "ta": [{ key: "../locales/ta.ts", load: () => import("../locales/ta.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_ta_ts" */), cache: true }],
  "sw": [{ key: "../locales/sw.ts", load: () => import("../locales/sw.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_sw_ts" */), cache: true }],
  "ro": [{ key: "../locales/ro.ts", load: () => import("../locales/ro.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_ro_ts" */), cache: true }],
  "el": [{ key: "../locales/el.ts", load: () => import("../locales/el.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_el_ts" */), cache: true }],
  "cs": [{ key: "../locales/cs.ts", load: () => import("../locales/cs.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_cs_ts" */), cache: true }],
  "hu": [{ key: "../locales/hu.ts", load: () => import("../locales/hu.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_hu_ts" */), cache: true }],
  "sv": [{ key: "../locales/sv.ts", load: () => import("../locales/sv.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_sv_ts" */), cache: true }],
  "fi": [{ key: "../locales/fi.ts", load: () => import("../locales/fi.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_fi_ts" */), cache: true }],
  "km": [{ key: "../locales/km.ts", load: () => import("../locales/km.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_km_ts" */), cache: true }],
  "ne": [{ key: "../locales/ne.ts", load: () => import("../locales/ne.ts" /* webpackChunkName: "locale__opt_buildhome_repo_locales_ne_ts" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "en",
      "language": "en-US",
      "files": [
        "/opt/buildhome/repo/locales/en.ts"
      ]
    },
    {
      "code": "es",
      "language": "es-ES",
      "files": [
        "/opt/buildhome/repo/locales/es.ts"
      ]
    },
    {
      "code": "zh",
      "language": "zh-CN",
      "files": [
        "/opt/buildhome/repo/locales/zh.ts"
      ]
    },
    {
      "code": "hi",
      "language": "hi-IN",
      "files": [
        "/opt/buildhome/repo/locales/hi.ts"
      ]
    },
    {
      "code": "ar",
      "language": "ar-SA",
      "files": [
        "/opt/buildhome/repo/locales/ar.ts"
      ]
    },
    {
      "code": "fr",
      "language": "fr-FR",
      "files": [
        "/opt/buildhome/repo/locales/fr.ts"
      ]
    },
    {
      "code": "pt",
      "language": "pt-PT",
      "files": [
        "/opt/buildhome/repo/locales/pt.ts"
      ]
    },
    {
      "code": "ja",
      "language": "ja-JP",
      "files": [
        "/opt/buildhome/repo/locales/ja.ts"
      ]
    },
    {
      "code": "de",
      "language": "de-DE",
      "files": [
        "/opt/buildhome/repo/locales/de.ts"
      ]
    },
    {
      "code": "vi",
      "language": "vi-VN",
      "files": [
        "/opt/buildhome/repo/locales/vi.ts"
      ]
    },
    {
      "code": "ko",
      "language": "ko-KR",
      "files": [
        "/opt/buildhome/repo/locales/ko.ts"
      ]
    },
    {
      "code": "ru",
      "language": "ru-RU",
      "files": [
        "/opt/buildhome/repo/locales/ru.ts"
      ]
    },
    {
      "code": "it",
      "language": "it-IT",
      "files": [
        "/opt/buildhome/repo/locales/it.ts"
      ]
    },
    {
      "code": "tr",
      "language": "tr-TR",
      "files": [
        "/opt/buildhome/repo/locales/tr.ts"
      ]
    },
    {
      "code": "id",
      "language": "id-ID",
      "files": [
        "/opt/buildhome/repo/locales/id.ts"
      ]
    },
    {
      "code": "th",
      "language": "th-TH",
      "files": [
        "/opt/buildhome/repo/locales/th.ts"
      ]
    },
    {
      "code": "bn",
      "language": "bn-BD",
      "files": [
        "/opt/buildhome/repo/locales/bn.ts"
      ]
    },
    {
      "code": "pl",
      "language": "pl-PL",
      "files": [
        "/opt/buildhome/repo/locales/pl.ts"
      ]
    },
    {
      "code": "nl",
      "language": "nl-NL",
      "files": [
        "/opt/buildhome/repo/locales/nl.ts"
      ]
    },
    {
      "code": "uk",
      "language": "uk-UA",
      "files": [
        "/opt/buildhome/repo/locales/uk.ts"
      ]
    },
    {
      "code": "ur",
      "language": "ur-PK",
      "files": [
        "/opt/buildhome/repo/locales/ur.ts"
      ]
    },
    {
      "code": "my",
      "language": "my-MM",
      "files": [
        "/opt/buildhome/repo/locales/my.ts"
      ]
    },
    {
      "code": "fa",
      "language": "fa-IR",
      "files": [
        "/opt/buildhome/repo/locales/fa.ts"
      ]
    },
    {
      "code": "he",
      "language": "he-IL",
      "files": [
        "/opt/buildhome/repo/locales/he.ts"
      ]
    },
    {
      "code": "ms",
      "language": "ms-MY",
      "files": [
        "/opt/buildhome/repo/locales/ms.ts"
      ]
    },
    {
      "code": "fil",
      "language": "fil-PH",
      "files": [
        "/opt/buildhome/repo/locales/fil.ts"
      ]
    },
    {
      "code": "ta",
      "language": "ta-IN",
      "files": [
        "/opt/buildhome/repo/locales/ta.ts"
      ]
    },
    {
      "code": "sw",
      "language": "sw-KE",
      "files": [
        "/opt/buildhome/repo/locales/sw.ts"
      ]
    },
    {
      "code": "ro",
      "language": "ro-RO",
      "files": [
        "/opt/buildhome/repo/locales/ro.ts"
      ]
    },
    {
      "code": "el",
      "language": "el-GR",
      "files": [
        "/opt/buildhome/repo/locales/el.ts"
      ]
    },
    {
      "code": "cs",
      "language": "cs-CZ",
      "files": [
        "/opt/buildhome/repo/locales/cs.ts"
      ]
    },
    {
      "code": "hu",
      "language": "hu-HU",
      "files": [
        "/opt/buildhome/repo/locales/hu.ts"
      ]
    },
    {
      "code": "sv",
      "language": "sv-SE",
      "files": [
        "/opt/buildhome/repo/locales/sv.ts"
      ]
    },
    {
      "code": "fi",
      "language": "fi-FI",
      "files": [
        "/opt/buildhome/repo/locales/fi.ts"
      ]
    },
    {
      "code": "km",
      "language": "km-KH",
      "files": [
        "/opt/buildhome/repo/locales/km.ts"
      ]
    },
    {
      "code": "ne",
      "language": "ne-NP",
      "files": [
        "/opt/buildhome/repo/locales/ne.ts"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": true,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "en",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "language": "en-US",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/en.ts"
      }
    ]
  },
  {
    "code": "es",
    "language": "es-ES",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/es.ts"
      }
    ]
  },
  {
    "code": "zh",
    "language": "zh-CN",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/zh.ts"
      }
    ]
  },
  {
    "code": "hi",
    "language": "hi-IN",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/hi.ts"
      }
    ]
  },
  {
    "code": "ar",
    "language": "ar-SA",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/ar.ts"
      }
    ]
  },
  {
    "code": "fr",
    "language": "fr-FR",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/fr.ts"
      }
    ]
  },
  {
    "code": "pt",
    "language": "pt-PT",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/pt.ts"
      }
    ]
  },
  {
    "code": "ja",
    "language": "ja-JP",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/ja.ts"
      }
    ]
  },
  {
    "code": "de",
    "language": "de-DE",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/de.ts"
      }
    ]
  },
  {
    "code": "vi",
    "language": "vi-VN",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/vi.ts"
      }
    ]
  },
  {
    "code": "ko",
    "language": "ko-KR",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/ko.ts"
      }
    ]
  },
  {
    "code": "ru",
    "language": "ru-RU",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/ru.ts"
      }
    ]
  },
  {
    "code": "it",
    "language": "it-IT",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/it.ts"
      }
    ]
  },
  {
    "code": "tr",
    "language": "tr-TR",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/tr.ts"
      }
    ]
  },
  {
    "code": "id",
    "language": "id-ID",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/id.ts"
      }
    ]
  },
  {
    "code": "th",
    "language": "th-TH",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/th.ts"
      }
    ]
  },
  {
    "code": "bn",
    "language": "bn-BD",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/bn.ts"
      }
    ]
  },
  {
    "code": "pl",
    "language": "pl-PL",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/pl.ts"
      }
    ]
  },
  {
    "code": "nl",
    "language": "nl-NL",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/nl.ts"
      }
    ]
  },
  {
    "code": "uk",
    "language": "uk-UA",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/uk.ts"
      }
    ]
  },
  {
    "code": "ur",
    "language": "ur-PK",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/ur.ts"
      }
    ]
  },
  {
    "code": "my",
    "language": "my-MM",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/my.ts"
      }
    ]
  },
  {
    "code": "fa",
    "language": "fa-IR",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/fa.ts"
      }
    ]
  },
  {
    "code": "he",
    "language": "he-IL",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/he.ts"
      }
    ]
  },
  {
    "code": "ms",
    "language": "ms-MY",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/ms.ts"
      }
    ]
  },
  {
    "code": "fil",
    "language": "fil-PH",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/fil.ts"
      }
    ]
  },
  {
    "code": "ta",
    "language": "ta-IN",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/ta.ts"
      }
    ]
  },
  {
    "code": "sw",
    "language": "sw-KE",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/sw.ts"
      }
    ]
  },
  {
    "code": "ro",
    "language": "ro-RO",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/ro.ts"
      }
    ]
  },
  {
    "code": "el",
    "language": "el-GR",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/el.ts"
      }
    ]
  },
  {
    "code": "cs",
    "language": "cs-CZ",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/cs.ts"
      }
    ]
  },
  {
    "code": "hu",
    "language": "hu-HU",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/hu.ts"
      }
    ]
  },
  {
    "code": "sv",
    "language": "sv-SE",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/sv.ts"
      }
    ]
  },
  {
    "code": "fi",
    "language": "fi-FI",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/fi.ts"
      }
    ]
  },
  {
    "code": "km",
    "language": "km-KH",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/km.ts"
      }
    ]
  },
  {
    "code": "ne",
    "language": "ne-NP",
    "files": [
      {
        "path": "/opt/buildhome/repo/locales/ne.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
